export default "__VITE_ASSET__DWj06AXp__"